import React from 'react';

const variantStyles = {
  primary: 'bg-[#3D52A0] text-white hover:bg-[#2D3F80] border-transparent shadow-sm',
  secondary: 'bg-[#F4F3F0] text-[#1A1915] hover:bg-[#E8E7E3] border-[#E5E3DE]',
  ghost: 'bg-transparent text-[#5C5A54] hover:bg-[#F4F3F0] border-transparent',
  danger: 'bg-[#C0222B] text-white hover:bg-[#A01B22] border-transparent shadow-sm',
  success: 'bg-[#1A6B3E] text-white hover:bg-[#145530] border-transparent shadow-sm',
  outline: 'bg-white text-[#3D52A0] hover:bg-[#EEF0FB] border-[#3D52A0]',
};

const sizeStyles = {
  xs: 'px-2 py-1 text-xs gap-1',
  sm: 'px-3 py-1.5 text-sm gap-1.5',
  md: 'px-4 py-2 text-sm gap-2',
  lg: 'px-6 py-2.5 text-base gap-2',
};

export default function Button({
  children, variant = 'secondary', size = 'md', icon, iconRight, loading,
  className = '', disabled, ...props
}) {
  return (
    <button
      className={`inline-flex items-center justify-center font-medium rounded-lg border transition-all duration-150 cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed ${variantStyles[variant] || variantStyles.secondary} ${sizeStyles[size] || sizeStyles.md} ${className}`}
      disabled={disabled || loading}
      {...props}
    >
      {loading ? (
        <svg className="animate-spin w-4 h-4" viewBox="0 0 24 24" fill="none">
          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z" />
        </svg>
      ) : icon}
      {children}
      {iconRight}
    </button>
  );
}

export { Button };

